const sanityClient = require('@sanity/client')
export default sanityClient({
    projectId: "6nljrt1e", 
    dataset: "production", 
    useCdn: false,
    withCredentials: true
});
